import { BaseConfig } from "../config.interface";
import { Size, Validate } from "../util";

interface IDropdownConfig {
    label?: string;
    optionLabel?: string;
    optionValue?: string;
    autocomplete?: string;
    clear?: boolean;
    placeholder?: string;
    validate: Validate;
    size: Size | "full";
}
export class DropdownConfig extends BaseConfig<IDropdownConfig> implements IDropdownConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Property key of the option's label. 
     * - On primitive values defaults to `label`.
     * - On objects values this value assumes its a key of the value (`value.LABEL`) or fallbacks to `label`.
     */
    optionLabel?: string;
    /**
     * Property key of the option's value. 
     * - On primitive values or emptydefaults to `value`.
     * - On objects values this value assumes its a key of the value (`value.KEY`) or  fallbacks to `value`. 
     */
    optionValue?: string;
    /**
     * Property key of the option's group. 
     */
    optionGroup?: string;
    /**
     * Browser autocomplete attribute.
     */
    autocomplete?: string;
    /**
     * Show clear button.
     */
    clear?: boolean;
    /**
     * Placeholder on empty value.
     */
    placeholder?: string;
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;
    /**
     * Size of the input element.
     * @values "small" | "medium" | "large"
     */
    size: Size | "full";

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         */
        Default: new DropdownConfig({
            placeholder: "Bitte auswählen",
            clear:       true,
            validate:    "dirty",
            size:        "medium",
        }),
        EmptyLabel: new DropdownConfig({
            placeholder: "Bitte auswählen",
            clear:       true,
            validate:    "dirty",
            size:        "medium",
        }),
        Small: new DropdownConfig({
            placeholder: "Bitte auswählen",
            clear:       true,
            validate:    "dirty",
            size:        "small",
        }),
        Large: new DropdownConfig({
            placeholder: "Bitte auswählen",
            clear:       true,
            validate:    "dirty",
            size:        "large",
        }),
        Full: new DropdownConfig({
            placeholder: "Bitte auswählen",
            clear:       true,
            validate:    "dirty",
            size:        "full",
        }),
        smallAddOn: new DropdownConfig({
            placeholder: "Wählen",
            clear:       false,
            validate:    "dirty",
            size:        "medium",
        }),
        SmallNoClear: new DropdownConfig({
            placeholder: "Bitte auswählen",
            clear:       false,
            validate:    "dirty",
            size:        "small",
        }),
        NoClear: new DropdownConfig({
            placeholder: "Bitte auswählen",
            clear:       false,
            validate:    "dirty",
            size:        "medium",
        }),
        LargeNoClear: new DropdownConfig({
            placeholder: "Bitte auswählen",
            clear:       false,
            validate:    "dirty",
            size:        "large",
        })

    };
}